// export function getHouseTypeName(name) {
//     const store = {
//         jengapolepole: "Jenga Pole Pole",
//     };
//     if (name in store) {
//         return store[name];
//     }

//     const capitalize = (s) => {
//         if (typeof s !== "string") return "";
//         return s.charAt(0).toUpperCase() + s.slice(1);
//     };

//     return capitalize(name);
// }

/**
 * Analyse plans by: house_type, bedrooms, bathrooms, minimum_plot_size
 * @param {Array} plans - List of plans to be analysed
 * @returns {Object} Example: { "house_type": {"bungalow": 4,"maisonette": 2 }, "bedrooms": {"3": 3,"4": 3 }, "bathrooms": {"2": 4,"4": 2 }, "minimum_plot_size": {"30x60": 2,"40x80": 2,"50x100": 2 }  }
 */
export default function countPlanFeatures(plans) {
    let house_type = {};
    let bedrooms = {};
    let bathrooms = {};
    let minimum_plot_size = {};

    plans.forEach((plan) => {
        //

        // house_type
        if (plan.house_type in house_type) {
            house_type[plan.house_type] = house_type[plan.house_type] + 1;
        } else if (!!plan.house_type) {
            house_type[plan.house_type] = 1;
        }

        // bedrooms
        if (plan.bedrooms in bedrooms) {
            bedrooms[plan.bedrooms] = bedrooms[plan.bedrooms] + 1;
        } else if (!!plan.bedrooms) {
            bedrooms[plan.bedrooms] = 1;
        }

        // bathrooms
        if (plan.bathrooms in bathrooms) {
            bathrooms[plan.bathrooms] = bathrooms[plan.bathrooms] + 1;
        } else if (!!plan.bathrooms) {
            bathrooms[plan.bathrooms] = 1;
        }

        // minimum_plot_size
        if (plan.minimum_plot_size in minimum_plot_size) {
            minimum_plot_size[plan.minimum_plot_size] =
                minimum_plot_size[plan.minimum_plot_size] + 1;
        } else if (!!plan.minimum_plot_size) {
            minimum_plot_size[plan.minimum_plot_size] = 1;
        }
    });

    const plansFeatures = {
        house_type,
        bedrooms,
        bathrooms,
        minimum_plot_size,
    };

    return plansFeatures;
}
